export default "__VITE_ASSET__gsy49iNM__"